import type { ConversationAttachmentUrlResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

/**
 * A short signed link to a file a creator sent (15 minutes). Read on mount and
 * again before it expires; an image that fails to load asks for a new one.
 */
export const useConversationAttachmentUrlQuery = (conversationId: string, mediaId: string) =>
  useQuery<ConversationAttachmentUrlResponse, Error>({
    queryKey: ['conversation-attachment-url', conversationId, mediaId],
    queryFn: async () => {
      const response = await api.get(
        `/dashboard/conversations/${conversationId}/attachments/${mediaId}/url`
      );
      return response.data.data;
    },
    staleTime: 1000 * 60 * 10,
    refetchInterval: 1000 * 60 * 12,
    retry: false,
    refetchOnWindowFocus: false,
  });
